<lib-cdw-user-collection-edit
  #userCollectionEdit
  *ngIf="!isLoading && (currentUserCollection || selectedUserCollectionId === 'new')"
  [selectedUsers]="currentUserCollectionUsers"
  [userCollection]="currentUserCollection"
  [users]="users"
  (deleteUserCollection)="onDeleteUserCollection()"
  (submitUserCollectionEdit)="onSubmitEdit($event)"
  (cancelUserCollectionEdit)="onCancelEdit()"
  (openCsvUpload)="onOpenCsvUpload()"
></lib-cdw-user-collection-edit>
